import {
  DefinitionList,
  Header,
  Icons,
  InvisiButton,
  MultiselectSingularDropdown,
  SuperScript
} from '@eggplant/pattern-library'
import type { CSSProperties, ReactNode } from 'react'
import type { Requirement } from '@eggplant/types'

interface Props {
  preferredPosition?: 'left' | 'right'
  onChange: (value: string[]) => void
  requirementData: Requirement[]
  value?: string[]
  onIsOpenStateChange?: (value: boolean) => void
}

interface Option {
  label: string
  value: string
}

export interface Group {
  label: string
  options: Option[]
}

const iconWrapperStyle: CSSProperties = {
  height: '24px',
  width: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const overflowWrapperStyle: CSSProperties = {
  display: 'grid',
  rowGap: '12px',
  lineHeight: '18px',
  width: 366,
  maxHeight: 140,
  overflowY: 'auto',
  wordBreak: 'break-word'
}

const getOptions = (items: Requirement[]) =>
  items.map(({ external_id, id }) => ({
    label: external_id,
    value: id
  }))

const SelectMultipleRequirements = ({
  preferredPosition = 'left',
  onChange,
  requirementData,
  value = [],
  onIsOpenStateChange
}: Props) => {
  const renderButton = (props: object) => {
    const selectedValueCount = value.length
      ? value.length.toString()
      : ''

    return (
      <SuperScript value={selectedValueCount}>
        <InvisiButton
          {...props}
          title='Add requirements'
        >
          <span style={iconWrapperStyle}>
            <Icons.Requirements size='18' />
          </span>
        </InvisiButton>
      </SuperScript>
    )
  }

  const renderOptionTooltip = (currentOption: Option): ReactNode => {
    const requirement = requirementData.find(requirement => requirement.id === currentOption.value)

    return (
      <div
        aria-label='PopOutContent'
        style={overflowWrapperStyle}
      >
        <Header
          hasNoTopMargin
          rank={4}
        >
          {requirement?.external_id}
        </Header>
        <DefinitionList variant='below'>
          {{
            Description: requirement?.description
          }}
        </DefinitionList>
      </div>
    )
  }

  return (
    <div>
      <MultiselectSingularDropdown
        capacity={20}
        hasDropdownWithNarrowGap
        onChange={onChange}
        onIsOpenStateChange={onIsOpenStateChange}
        optionListGroups={getOptions(requirementData)}
        preferredPosition={preferredPosition}
        renderButton={renderButton}
        renderOptionTooltip={renderOptionTooltip}
        selectedValueList={value}
      />
    </div>
  )
}

export default SelectMultipleRequirements
